import { Component } from '@angular/core';
import { NotificationService } from '../../../../../service';

@Component({
  standalone: false,
  selector: 'siths-eid-admin-privileges-rules',
  templateUrl: './privileges-rules.component.html',
  styleUrls: ['./privileges-rules.component.scss']
})
export class PrivilegesRulesComponent {
  constructor(private notificationService: NotificationService) {}

  public importError(): void {
    this.notificationService.warning('Ogiltigt format');
  }
}
